import { GraduationCap } from "lucide-react";
import { AnimatedSection } from "./AnimatedSection";

const POINTS = [
  {
    title: "Eligibility & Duration",
    body: "A two-month course open to +2 Commerce and B.Com students.",
  },
  {
    title: "Practical Curriculum",
    body: "Learn foundational rules, journal entries, Payroll, PF, ESI, TDS, GST returns, and IT calculations.",
  },
  {
    title: "Software & Job Readiness",
    body: "Includes intensive basic Tally coaching, practical journal entry posting, and dedicated interview and technical round preparation.",
  },
];

const INSTITUTE_WHATSAPP =
  "https://wa.me/919361856352?text=Hello%2C%20I%27d%20like%20to%20know%20more%20about%20the%20Accountant%20Training%20Institute.";

export const TrainingInstitute = () => (
  <section id="training" className="bg-[#0A1128] py-24 md:py-32 relative overflow-hidden">
    <div className="grain-overlay" />
    <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
      <div className="grid lg:grid-cols-12 gap-16 items-start">
        <AnimatedSection className="lg:col-span-5">
          <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-6">
            <GraduationCap size={20} className="text-[#C5A059]" />
          </div>
          <p className="overline text-[#C5A059] mb-4">Grow High Accountant Training</p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-white mb-6 leading-tight">
            Launch your career in accounting.
          </h2>
          <p className="text-slate-300 leading-relaxed mb-8">
            An online program offering comprehensive, hands-on training to make you job-ready.
          </p>
          <a
            href={INSTITUTE_WHATSAPP}
            target="_blank"
            rel="noreferrer"
            data-testid="training-enquire-btn"
            className="inline-flex items-center gap-2 rounded-full bg-[#C5A059] text-[#0A1128] px-7 py-3.5 text-base font-medium hover:bg-[#d4b06f] transition-colors duration-300"
          >
            Enquire About the Course
          </a>
        </AnimatedSection>

        <div className="lg:col-span-7 space-y-8">
          {POINTS.map((p, i) => (
            <AnimatedSection
              key={p.title}
              delay={i * 0.15}
              data-testid={`training-point-${i}`}
              className="border-t border-white/10 pt-8"
            >
              <h3 className="font-serif text-2xl text-white mb-3">{p.title}</h3>
              <p className="text-slate-300 leading-relaxed text-base md:text-lg">{p.body}</p>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </div>
  </section>
);
